// src/pages/Location.js
import React from 'react';
import DirectionsInfo from '../components/location/DirectionsInfo';
import Map from '../components/location/Map';
import useIntersectionObserver from '../hooks/useIntersectionObserver';

const Location = () => {
  const [titleRef, isTitleVisible] = useIntersectionObserver();
  const [contentRef, isContentVisible] = useIntersectionObserver({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <div className="relative min-h-screen pt-20">
      {/* Tło z gradientem */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 to-black/50 z-10" />
        <img
          src="https://images.unsplash.com/photo-1672840997353-4579d5d6a7d5?q=80&w=1932&auto=format&fit=crop"
          alt=""
          className="w-full h-full object-cover object-center fixed"
          aria-hidden="true"
        />
      </div>

      {/* Zawartość strony */}
      <div className="relative z-20 container mx-auto px-4 py-12">
        {/* Nagłówek z animacją */}
        <div
          ref={titleRef}
          className={`
            text-center mb-12 transform transition-all duration-700 ease-out
            ${isTitleVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}
          `}
        >
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Jak do nas trafić?
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Znajdziesz nas w dogodnej lokalizacji z łatwym dojazdem i bezpłatnym parkingiem
          </p>
        </div>

        {/* Grid z mapą i informacjami */}
        <div 
          ref={contentRef}
          className={`
            grid lg:grid-cols-2 gap-8 max-w-7xl mx-auto
            transform transition-all duration-700 ease-out delay-300
            ${isContentVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}
          `}
        >
          {/* Kontener mapy */}
          <div className="h-[600px] lg:h-auto">
            <Map />
          </div>

          {/* Informacje kontaktowe i wskazówki dojazdu */}
          <DirectionsInfo />
        </div>
      </div>
    </div>
  );
};

export default Location;